import { Outlet, useNavigate } from "react-router-dom";
import SideMenu from "./SideMenu";
import styled from "styled-components";
import { useEffect, useState} from "react";
import Loading from "components/Loading";
import {
  ACCESS_TOKEN_NAME, getClass, getImageUrl,
  getSiteOne, getUserOne, removeStorage,
  SELECT_SITE_ID, SITE_ID_LIST, USER_ID, USER_ROLE
} from "api/api";
import { colors } from "styles/global-styles";
import { CURRENTYEAR, fetchHolidaysByYear, ROLE_DIRECTOR, ROLE_PARENT, ROLE_TEACHER } from "utils/commonUtils";
import { BearSVG, GrassSVG } from "styles/global-styles";
import { ClassInfo, ClassQueryParams, ListResult, UserInfo} from "../../type/type";
import DefaultProfileS from "../../assets/image/common/default_profile_S.svg";
import { useLoginUserInfo } from "../../redux/hook/useLoginUserInfo";
import { useSetRecoilState } from "recoil";
import { holidayState, selectSiteIdState, userRoleState } from "styles/atoms";

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow-y: hidden;

  .show {
    display: inline-block;
  }
  .none {
    display: none;
  }

  // 공통 텍스트 color
  .text-red {
    color: ${({ theme }) => theme.newTheme.default.error};
  }
  .text-yellow{
    color: ${colors.yellow};
  }
  .text-gray{
    color: ${colors.darkGray};
  }
  .text-green{
    color: ${colors.green};
  }
  .text-blue {
    color: ${colors.blue};
  }
  .text-vermillion {
    color: ${colors.vermillion};
  }  
`;

// site name
const CenterTitle = styled.nav`
  position: absolute;
  top: 2rem;
  right: 2rem;
`;

// custom datePicker
export const CustomDatePickerWrap = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  min-width: 12.5rem;
  
  // 캘린더
  &.custom-date-picker {
    .react-datepicker-popper {
      z-index: 20;
    }
    // 캘린더 상단 삼각형(날짜 선택 클릭 시 input창을 가리키는 화살표)
    .react-datepicker__triangle {
      display: none;
    }
    .react-datepicker__aria-live {
      display: none;
    }
    
    .holiday {
      color: ${colors.red};
    }
    .holiday_sun {
      color: ${colors.red};
    }
    .holiday_sat {
      color: ${colors.blue};
    }
    .selectedDay:not(.react-datepicker__day--outside-month) {
      background-color: ${({theme}) => theme.newTheme.default.primary};
      color: ${({theme}) => theme.newTheme.text.btnText_w};
      border-radius: 50%;
    }
    .selectedMonth:not(.react-datepicker__day--outside-month) {
      background-color: ${({theme}) => theme.newTheme.default.primary};
      color: ${({theme}) => theme.newTheme.text.btnText_w};
      border-radius: 50%;
    }
    .react-datepicker__month-container {
      background-color: ${({theme}) => theme.rootWhite};
      border-radius: 0.5rem;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.18);
    }
    .react-datepicker__view-calendar-icon {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .custom-header-container {
      min-width: 16rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      margin-top: 0.5rem;
      padding: 0 0.5rem;
      > div:first-of-type {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
    .custom-month {
      background-color: transparent;
      font-family: var(--font-nanumSquare-acR);
      padding: 0.625rem 0.5rem;
      border: none;
    }
    .custom-month-button {
      width: 2.125rem;
      height: 2.125rem;
      padding: 0.375rem;
      &:hover:not(:disabled) {
        opacity: 0.6;
      }
      &:disabled {
        cursor: default;
        > img {
          opacity: 0.3;
        }
      }
    }
    .react-datepicker__day-names {
      padding: 0 1rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      color: ${({theme}) => theme.newTheme.text.btnText_disabled};
      .react-datepicker__day-name {
        text-align: center;
        width: 2rem;
        height: 2rem;
        line-height: 2rem;
      }
    }
    .react-datepicker__month {
      padding: 1rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .react-datepicker__week {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
      }
      .react-datepicker__day--outside-month {
        color: ${({theme}) => theme.newTheme.text.btnText_disabled};
      }
      .react-datepicker__month-text--disabled {
        color: ${({theme}) => theme.newTheme.text.btnText_disabled};
      }
      .react-datepicker__day {
        text-align: center;
        width: 2rem;
        height: 2rem;
        line-height: 2rem;
        &:hover {
          cursor: pointer;
          border-radius: 50%;
          background-color: ${({theme}) => theme.newTheme.default.secondary};
          color: ${({theme}) => theme.newTheme.default.accent};
        }
      }
      .react-datepicker__day--disabled {
        color: ${({ theme }) => theme.newTheme.text.btnText_disabled};
        &:hover {
          cursor: default;
          background: none;
          color: ${({ theme }) => theme.newTheme.text.btnText_disabled};
        }
      }
      .react-datepicker__month-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .react-datepicker__month-text {
          text-align: center;
          width: 3rem;
          line-height: 3rem;
          &:not(.react-datepicker__month-text--disabled):hover {
            cursor: pointer;
            border-radius: 50%;
            background-color: ${({theme}) => theme.newTheme.default.secondary};
            color: ${({theme}) => theme.newTheme.default.accent};
          }
        }
      }
    }
    .react-datepicker__today-button {
      position: absolute;
      top: 1rem;
      right: 1rem;
      padding: 0.5rem;
      border-radius: 0.5rem;
      &:hover {
        background-color: ${({theme}) => theme.newTheme.default.secondary};
        color: ${({theme}) => theme.newTheme.default.accent};
      }
    }
    // modal datepicker + range picker
    &.modal-datepicker {
      position: relative;
      .react-datepicker__input-container {
        input {
          width: 100%;
        }
      }
      .react-datepicker__tab-loop {
        position: absolute;
        .react-datepicker-popper {
          transform: none !important;
          top: 10px !important;
        }
      }
      &.not-range {
        .react-datepicker-wrapper {
          width: 70%;
        }
        .react-datepicker__tab-loop .react-datepicker-popper {
          right: 0px;
          left: auto !important;
        }
      }
      .react-datepicker__day--in-range,
      .react-datepicker__day--in-selecting-range {
        background-color: ${({theme}) => theme.newTheme.default.secondary};
        color: ${({ theme }) => theme.newTheme.default.accent};
      }
      .react-datepicker__day--range-start,
      .react-datepicker__day--selecting-range-start,
      .react-datepicker__day--range-end,
      .react-datepicker__day--selecting-range-end,
      .react-datepicker__day--selecting-range-end:hover {
        background-color: ${({theme}) => theme.newTheme.default.primary};
        color: ${({theme}) => theme.newTheme.text.btnText_w};
      }
      .react-datepicker__day--range-start,
      .react-datepicker__day--selecting-range-start {
        border-top-right-radius: 0%;
        border-bottom-right-radius: 0%;
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
      }
      .react-datepicker__day--range-end,
      .react-datepicker__day--selecting-range-end,
      .react-datepicker__day--selecting-range-end:hover {
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
        border-top-left-radius: 0%;
        border-bottom-left-radius: 0%;
      }
    }
  }
`;

// ----------- page ---------------
// page 헤더부분 CSS
export const PageHeaderTitleButtonStyle = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  max-height: 3rem;

  p.header-title {
    font-family: var(--font-nanumSquare-acB);
    font-size: 2.125rem;
    line-height: 1.25;
  }
  .button-wrap {
    display: flex;
    gap: 0.5rem;
  }
`;

// page 헤더 제외 content의 container부분 CSS
export const PageArticleWrap = styled.div`
  width: 100%;
  height: calc(100% - 3rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;

  input[type="time"] {
    &.time-false {
      border: 1px solid ${({theme}) => theme.newTheme.default.error};
    }
  }
  
  // 필터검색부분 가장 바깥 nav
  .filter-container {
    background-color: ${({theme}) => theme.rootWhite};
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: row;
    gap: 2rem;
    
    // 하나의 필터 감싸고 있는 div
    .filter-wrap {
      display: flex;
      gap: 1rem;
      align-items: center;
      min-width: 12.5rem;
      > div:not(.checkbox-div-wrap) {
        width: 100%;
      }
    }
  }

  // 목록 - 필터 제외 list 부분 article
  .list-content-container {
    min-height: 18.75rem;
    height: 100%;
    background-color: ${({theme}) => theme.rootWhite};
    border-radius: 0.5rem;
    padding: 1rem 1.25rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  // (공지사항쪽 수정하기) 등록/수정 - 필터 제외 부분
  .edit-content-container {
    min-height: 16rem;
    height: 100%;
    background-color: ${({theme}) => theme.rootWhite};
    border-radius: 0.5rem;
    padding: 1.25rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &:first-of-type {
      grid-area: a;
    }
  }
  // 목록 - 출석부 상단 card 부분 (ul)
  .attendance-list-card-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
  .article-header {
    height: 1.25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    p:first-of-type {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
    }
    .article-header-title {
      color: ${({theme}) => theme.newTheme.default.text};
      font-weight: 600;
      font-size: 1rem;
    }
  }
  .article-header.height-auto {
    height: auto;
    p:first-of-type {
      align-items: center;
    }
  }
  .article-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    input[type="text"] {
      width: 100%;
      height: 3.5rem;
      padding: 0 1.25rem;
      font-size: 1.25rem;
      font-family: var(--font-nanumSquare-acB);
      background: none;
      border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
    }
    > div:last-of-type {
      height: 100%;
    }
    textarea {
      width: 100%;
      height: 100%;
      resize: none;
      border-radius: 0.5rem;
      padding: 0.625rem 1rem;
      border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
      font-size: 0.875rem;
      font-family: var(--font-nanumSquare-acR);
      &:focus-visible {
        outline: none;
      }
    }
  }
  .file-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .doc-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    overflow: auto;
  }
  .join-wrap {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: calc(100% - 1.25rem);
  }
`;

// content의 table부분
export const ListContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: calc(100% - 2.25rem - 1.25rem - 1rem);

  .list-one-wrap {
    height: calc(100% - 2.5rem);
    display: flex;
    gap: 1rem;
    overflow-x: auto;

    .list-table {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
    }
    .button-wrap {
      display: flex;
      gap: 0.5rem;
      justify-content: flex-end;
      margin-bottom: 0.5rem;
    }
    .list-table-header {
      position: sticky;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: ${({theme}) => theme.newTheme.table.tableHeadBg};
      color: ${({theme}) => theme.newTheme.table.tableHeadText};
      font-family: var(--font-nanumSquare-acB);
      border-radius: 0.5rem;
      z-index: 1;
      > div {
        padding: 0.5rem 1rem;
        font-size: 1rem;
        line-height: 1.25;
      }
    }
    .attendance-table-header {
      text-align: left;
      font-size: 1rem;
      font-family: var(--font-nanumSquare-acB);
      margin-bottom: 0.5rem;
    }
    .primary {
      overflow: auto;
      // scroll-snap-type: both mandatory;
      height: 80vh;
    }
  }
  .list-one-wrap.h100 {
    height: 100%;
  }
`;
// 수납항목 한 페이지에 2개의 content table 부분
export const TwoListContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: calc(100% - 2.25rem);
  .list-wrap {
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    padding-right: 0.25rem;
    .list-table {
      // position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      .w-20 {
        flex-grow: 1;
      }
    }
    .button-wrap {
      display: flex;
      gap: 0.5rem;
      justify-content: flex-end;
      margin-bottom: 0.5rem;
    }
    .list-table-header {
      position: sticky;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: ${({theme}) => theme.newTheme.table.tableHeadBg};
      color: ${({theme}) => theme.newTheme.table.tableHeadText};
      font-family: var(--font-nanumSquare-acB);
      border-radius: 0.5rem;
      z-index: 1;
      > div {
        padding: 0.5rem 1rem;
        font-size: 1rem;
      }
    }
    .attendance-table-header {
      text-align: left;
      font-size: 1rem;
      font-family: var(--font-nanumSquare-acB);
      padding: 0.5rem 0;
    }
    .primary {
      overflow: auto;
      // scroll-snap-type: both mandatory;
      height: 80vh;
    }
  }
`;

const BackgroundImageWrap = styled.div`
  position: absolute;
  right: 3rem;
  svg {
    position: absolute;
    &:first-of-type {
      right: -5rem;
      transform: rotateY(180deg);
      bottom: 6rem;
      z-index: -1;
      height: 2rem;
    }
    &:nth-of-type(2) {
      right: -11rem;
      bottom: 2rem;
    }
    &:last-of-type {
      right: -10rem;
      bottom: 0;
      width: 8.125rem;
    }
  }
`;

export const FlexGrow = styled.div`
  flex-grow: 1;
`;

export const EllipsisTextColumn = styled.div`
  white-space: nowrap;      /* 텍스트가 한 줄로 표시되도록 설정 */
  overflow: hidden;         /* 넘치는 텍스트를 숨김 */
  text-overflow: ellipsis;  /* 넘친 텍스트를 '...'로 표시 */
`

function Layout() {

  const { updateLoginUserInfo, updateUserMainImageUrl } = useLoginUserInfo();
  // 전역 사용
  const setUserRole = useSetRecoilState(userRoleState);
  const setSelectSiteIdState = useSetRecoilState(selectSiteIdState);

  // 전역으로 공휴일 사용을 위함
  const setHolidayList = useSetRecoilState(holidayState);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // 로딩 상태를 기본으로 true로 설정
  const [siteName, setSiteName] = useState<string>('');

  // 로컬 스토리지에서 유저 정보 가져오기
  const getLocalStorageData = () => {
    const accessToken:string|null = localStorage.getItem(ACCESS_TOKEN_NAME);
    const userId:number = Number(localStorage.getItem(USER_ID));
    const userRole:string|null = localStorage.getItem(USER_ROLE);
    const siteIdList:number[] = JSON.parse(localStorage.getItem(SITE_ID_LIST) || '[]');
    const selectSiteId:number| null = Number(localStorage.getItem(SELECT_SITE_ID));

    if (!accessToken || !userId) {
      removeStorage();
      navigate('/login');
      return null;
    }

    return {
      access_token: accessToken,
      user_id: userId,
      user_role: userRole,
      site_id_list: siteIdList,
      select_site_id: selectSiteId
    };
  };

  // 유저 정보 및 사이트 정보 가져오는 비동기 함수
  const fetchUserData = async () => {
    try {

      const localData = getLocalStorageData();
      if (!localData) return;
      
      // 학부모인 경우 로컬스토리지 삭제 및 로그인페이지로 이동
      if (localData.user_role === ROLE_PARENT) {
        alert('학부모님께서는 아이스쿨(AI SCHOOL) 앱을 이용해주세요.');

        navigate('/login');
        removeStorage();
        return;
      }

      const siteIdByLocalStorage = Number(localStorage.getItem(SELECT_SITE_ID));
      const userRole:string = localData.user_role || '';
      const userId:number = Number(localData.user_id) || 0;

      const [siteResult, userResult] = await Promise.all([getSiteOne(), getUserOne(userId)]);

      if (siteResult.code !== 200 || userResult.code !== 200) {
        alert(siteResult.code !== 200 ? '사이트 정보를 가져오는데 실패했습니다.' : userResult.message);
        navigate('/login');
        return;
      }
      else {

        //담당반 클래스 아이디 리스트 업데이트
        const classQueryParams: ClassQueryParams = {
          name: "",
          user_id: userRole === ROLE_DIRECTOR ? 0 : userId,
          response_format: "",
          page: 1,
          size: 99999999
        };

        //클래스 조회
        const classResult: ListResult<ClassInfo> = await getClass(classQueryParams);

        if (classResult.code !== 200) {
          alert(classResult.message);
          navigate('/login');
          return;
        }

        // selectSiteId를 Recoil state에 저장
        setSelectSiteIdState(siteIdByLocalStorage);

        // userRole을 Recoil state에 저장
        setUserRole(userRole);
        
        //업장 이름 표시
        setSiteName(siteResult.data.name);

        // 로그인 유저 정보 업데이트
        updateLoginUserInfo(localData, userResult.data, siteIdByLocalStorage);

        //사용자의 메인 이미지 URL (display용)
        const userInfo: UserInfo = userResult.data;
        
        //이미지 리스트가 존재하면
        if (userInfo.image_list.length > 0) {
          updateUserMainImageUrl(getImageUrl(userInfo.image_list[0].file_name));
        } else {
          updateUserMainImageUrl(DefaultProfileS);
        }

        // 사이트 이름이 없는 경우 [학교 기본정보] 페이지로 이동
        if (!siteResult.data.name) {
          navigate('/setting/siteInformation');
          alert("학교 기본 정보를 먼저 설정해주세요.");
        }

      }

      // 대한민국 공휴일 라이브러리 사용
      let _holidays: string[] = [];
      // 이번년도 포함 총 4년 데이터
      for (let i = 0; i <= 3; i++) {
        let yyyy = CURRENTYEAR - i;
        const holidays = await fetchHolidaysByYear(yyyy);
        if (holidays) _holidays = [..._holidays, ...holidays];

      }

      if (_holidays.length) setHolidayList(_holidays);
      else setHolidayList([]);

      setLoading(false);

    }
    catch (error) {
      console.error('데이터 가져오기 오류', error);
      
      navigate('/login');
    }
  };

  // 모든 초기화 및 API 호출을 하나의 useEffect로 처리
  useEffect(() => {
    fetchUserData();
  }, []); // 빈 배열을 의존성으로 사용하여 첫 렌더링 시 한 번만 실행


  // localStorage에서 하나라도 삭제 시 login 페이지로 이동
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem(ACCESS_TOKEN_NAME);
      const id = localStorage.getItem(USER_ID);
      const role = localStorage.getItem(USER_ROLE);
      const siteList = localStorage.getItem(SITE_ID_LIST);
      const siteId = localStorage.getItem(SELECT_SITE_ID);

      if (!token || !id || !role || !siteList || !siteId) {
        navigate('/login'); // 로그인 페이지로 이동
      };

    };
    
    // 초기 체크
    checkAuth();

    // storage 이벤트 리스너 등록
    window.addEventListener('storage', checkAuth);

    // 컴포넌트 언마운트 시 리스너 제거
    return () => {
      window.removeEventListener('storage', checkAuth);
    };

  }, [navigate]);

  return (
    loading ? <Loading />
      :
      <RootContainer>
        <SideMenu />
        <main id="outsideMainContainer">
          <section id="commonMainContainer">
            <CenterTitle>{siteName}</CenterTitle>
            <Outlet />
          </section>
          <BackgroundImageWrap>
            <GrassSVG />
            <GrassSVG />
            <BearSVG />
          </BackgroundImageWrap>
        </main>
      </RootContainer>
  );
}

export default Layout;